module.exports = __webpack_public_path__ + "static/img/011.5fd8a1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/factory/011.jpg
// module id = jnBY
// module chunks = 1